const getProductUrl = (product) => {
	const { handle = "", variant = {}, variants = [] } = product || {};
	const path = `/products/${handle}`;
	// If it's a single variant product, return the product URL
	if (variants.length <= 1) return path;
	const firstVariantHandle = variants[0].handle;

	if (!variant.isAvailable) {
		const availableVariant = variants.find(variant => variant.isAvailable);
		return availableVariant && availableVariant.handle !== firstVariantHandle ? `${path}/${availableVariant.handle}` : path;
	}

	return variant.handle !== firstVariantHandle ? `${path}/${variant.handle}` : path;
};

export default getProductUrl;